/**
 * Legende der Zellzustaende (D-17, Sketch 023 `lockLegend()`). Bewusst OHNE die
 * Hover-Sperrvariante des Sketches -- diese Phase kennt nur die Klick-Bedienung (D-14).
 */
import type { CSSProperties } from 'react';
import { IconLock } from '@tabler/icons-react';
import { statusPalette, vdzOrange } from '../../theme/colors';
import classes from './evaluationTable.module.css';

const legendColorVars = {
  '--eval-blocked-fg': statusPalette.fehler.fg,
} as CSSProperties;

const DEFAULT_EXTRA = 'Name anklicken: Aufschlüsselung je Werk';

export interface LockLegendProps {
  extra?: string;
}

export function LockLegend({ extra }: LockLegendProps) {
  return (
    <div className={classes.legend} style={legendColorVars}>
      <span className={classes.legendItem}>
        <span
          className={classes.legendSwatch}
          style={{
            background: statusPalette.fehler.bg,
            border: `1px solid ${statusPalette.fehler.border}`,
          }}
        />
        gesperrt
      </span>
      <span className={classes.legendItem}>
        <span
          className={`${classes.legendSwatch} ${classes.legendSwatchTriangle}`}
        />
        von Hand entschieden
      </span>
      <span className={classes.legendItem}>
        <span
          className={classes.legendSwatch}
          style={{
            outline: `1.5px dashed ${statusPalette.fehler.fg}`,
            outlineOffset: '-2px',
          }}
        />
        trotz Regel freigegeben
      </span>
      <span className={classes.legendItem}>
        <span
          className={classes.legendSwatch}
          style={{ boxShadow: `inset 0 0 0 2px ${vdzOrange[6]}` }}
        />
        lässt sich zurückrechnen
      </span>
      <span className={classes.legendItem}>
        <IconLock size={12} color={statusPalette.fehler.fg} /> Vorjahr: im
        Vorjahr gesperrt, wird nicht übertragen
      </span>
      <span className={classes.legendItem}>
        Wert anklicken: sperren oder freigeben
      </span>
      <span className={classes.legendItem}>{extra ?? DEFAULT_EXTRA}</span>
    </div>
  );
}
